import { UseSuspenseQueryResult } from "@tanstack/react-query";

import { JSX } from "react";
import { useTranslation } from "react-i18next";

import GroupCard from "@/components/cards/GroupCard.tsx";
import Carousel from "@/components/helpers/Carousel.tsx";
import SectionSkeleton from "@/components/helpers/Section/Section.skeleton";
import Section from "@/components/helpers/Section/Section.tsx";

import { Collection } from "@/api/content/content.types.ts";
import { ROUTES } from "@/config/routes.ts";
import { isMobile } from "@/utils/constatns";

const SearchCollectionsSection = ({
  collections,
}: {
  collections: UseSuspenseQueryResult<Collection[], Error>;
}): JSX.Element => {
  const { t } = useTranslation();

  const { data, isPending } = collections;

  if (isPending) {
    return <SectionSkeleton type={"collection"} title={t("General.collection")} />;
  }

  if (data.length == 0) return <></>;

  return (
    <Section title={t("General.collection", { count: 5 })} className={"group/groups"}>
      <Carousel<Collection>
        swiperParams={{
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 16,
          followFinger: isMobile,
          breakpoints: {
            640: { slidesPerView: 3, slidesPerGroup: 3 },
            1024: { slidesPerView: 4, slidesPerGroup: 4 },
            1280: { slidesPerView: 5, slidesPerGroup: 5, spaceBetween: 12 },
            1440: { slidesPerView: 6, slidesPerGroup: 6, spaceBetween: 16 },
          },
        }}
        items={data}
        swiperName={"collection"}
      >
        {(collection) => (
          <GroupCard
            title={collection.title}
            link={ROUTES.MAIN.COLLECTION.replace(":id", collection.id.toString())}
            imageSrc={collection.picture.small}
          />
        )}
      </Carousel>
    </Section>
  );
};

export default SearchCollectionsSection;
